package com.essntl.features.crm.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.features.crm.ui.CRMNavigation
import com.essntl.features.crm.ui.CRMState
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun OrganizationListColumn(
    state: CRMState,
    onNavigation: (CRMNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    val lazyListState = rememberLazyListState()

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary),
    ) {
        if (state.getOrganizationList.isLoading)
            EsSpinner()
        else if (state.getOrganizationList.isFailure)
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
                textAlign = TextAlign.Center,
            )
        else if (state.getOrganizationList.data.orEmpty().isEmpty())
            Text(
                text = "No organizations Found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
                textAlign = TextAlign.Center,
            )
        else
            LazyColumn(
                horizontalAlignment = Alignment.CenterHorizontally,
                state = lazyListState,
                modifier = Modifier.fillMaxSize(),
            ) {
                itemsIndexed(state.getOrganizationList.data.orEmpty()) { index, organization ->
                    OrganizationItem(
                        organizationListModel = organization,
                        state = state,
                        onNavigation = onNavigation,
                        index = index,
                        modifier = Modifier.padding(
                            horizontal = EsConstants.SectionHorizontalPadding,
                        ),
                    )
                }
            }
    }
}